import { ObjectHelper } from '../../../../../apps/idl/src/helpers/objectHelper';

export class NotImplementedError extends Error {

	constructor(psMessage: string = "Not implemented.") {
		super(psMessage);
		// Nécessaire pour que le 'instanceof NotImplementedError' fonctionne (fonctionne sans uniquement sur le tsPlayground).
		ObjectHelper.initInstanceOf(this, NotImplementedError);
	}

}